import script from "./NewsPageToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageToolbar.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageToolbar.vue?vue&type=style&index=0&id=5fc4992d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc4992d"]])

export default __exports__